import * as ACTION_TYPES from '../actions/action_types';
import produce from 'immer';

const isEUCountry = ((countries, code) => {
    return countries.filter(c => (c.eu == 1 && c.code == code)).length > 0;
});

const getVATRate = ((countries, code) => {
    let country = countries.filter(c => (c.code == code))[0];
    return (country ? country.vat : 0);
});


export default function Reducer(state, action) {
    switch (action.type) {
        case ACTION_TYPES.SET_MAINTENANCE:
            return produce(state, (draft) => {
                draft.app.maintenance = true;
            });
        case ACTION_TYPES.TOGGLE_UI_FILTER:
            return produce(state, (draft) => {
                draft.ui['filterPIdx'] = action.payload;
            });
        case ACTION_TYPES.NAVIGATE:
            return produce(state, (draft) => {
                draft.ui.pageName = action.payload;
                draft.ui.redirect = true;
            });
        case ACTION_TYPES.RESET_NAVIGATE:
            return produce(state, (draft) => {
                draft.ui.redirect = false;
            });

        case ACTION_TYPES.SET_USER_DETAILS:
            return produce(state, (draft) => {
                draft.user = { ...draft.user, ...action.payload };
                draft.lang = draft.user.lang || action.payload.sessionLang || 'en';
                draft.user.guest = Boolean(draft.user.status == "Guest");
                draft.user.vatId = draft.user.companyName ? draft.user.vatId : null;
                draft.checkout.education.contactMail = (draft.user.guest == false) ? draft.user.mail : null;
                draft.checkout.taxIncluded = (!draft.user.country) || (draft.user.country && ((draft.user.country === "DE") || (isEUCountry(state.checkout.countries, draft.user.country) && !draft.user.vatId)));
                draft.checkout.taxMode = draft.checkout.taxIncluded ? 1 : isEUCountry(state.checkout.countries, draft.user.country) ? 2 : 3;
                draft.checkout.vatRate = getVATRate(state.checkout.countries, draft.user.country || "DE");
                draft.user.invoiceAddressComplete = (draft.user.name && draft.user.country && draft.user.zip && draft.user.city && draft.user.address1);

                draft.user.totalCredits = (draft.user.license.code) ?
                    (draft.user.license.remaining == -1) ? 9999 : draft.user.credits + draft.user.license.remaining : draft.user.credits;
                // just logged in: reset wizard steps
                resetWizardStepsOnLogin(state, draft);
            });

        case ACTION_TYPES.SET_ACTIVE_SOURCE:
            return produce(state, (draft) => {
                draft.activeSource = action.payload;
            });
        case ACTION_TYPES.SET_SOURCES:
            return produce(state, (draft) => {
                draft.sources = action.payload;
                draft.loadingSource = true;
                // In case one source is active, also update the active source with the new sources state
                if (state.activeSource.Id) {
                    draft.activeSource = draft.sources.filter(source => source.Id == state.activeSource.Id);
                }

            });
        case ACTION_TYPES.GET_REPORTS:
            return produce(state, (draft) => {
                draft.reports = [];
                draft.reports = action.payload.data;
                draft.totalReportsNumber = action.payload.total;
                draft.mapReportId2ReportIdx = {};
                draft.reports.map((report, idx) => {
                    draft.mapReportId2ReportIdx[report.Id] = idx;
                });
            });
        case ACTION_TYPES.GET_REPORTS_DASHBOARD:
            return produce(state, (draft) => {
                draft.reportsDashboard = [];
                draft.reportsDashboard = action.payload.data;
            });
        case ACTION_TYPES.SET_LIBTEXTS:
            return produce(state, (draft) => {
                draft.libraries = [];
                draft.libraries = action.payload.data;
                draft.totalLibrariesNumber = action.payload.total;
                draft.mapLibraryId2LibraryIdx = {};
                draft.libraries.map((library, idx) => {
                    draft.mapLibraryId2LibraryIdx[library.Id] = idx;
                });
            });
        case ACTION_TYPES.SET_MESSAGE_LIST:
            return produce(state, (draft) => {
                draft.messageList = action.payload.data;
            });
        case ACTION_TYPES.SET_SEARCHED_SOURCES:
            return produce(state, (draft) => {
                draft.searchedSources = action.payload;
            });
        case ACTION_TYPES.GET_REPORT_MARKUP:
            return produce(state, (draft) => {
                draft.reportMarkup = action.payload;
                draft.loadingSourceDetail = true;
            });
        case ACTION_TYPES.SET_TEXT_OVERLAY:
            return produce(state, (draft) => {
                draft.textOverlay = action.payload;
                draft.loadingSourceDetail = true;
            });
        case ACTION_TYPES.SET_OVERLAY_STATISTICS:
            return produce(state, (draft) => {
                draft.overlayStatistics = action.payload;
                draft.loadingSourceDetail = true;
            });
        case ACTION_TYPES.GET_REPORT:
            return produce(state, (draft) => {
                draft.activeReport = action.payload;
                draft.activeReportId = Number(action.payload.Id);
                draft.reportSourceStatus = false;
                draft.loadingReportDetail = true;
            });
        case ACTION_TYPES.GET_LIBRARY:
            return produce(state, (draft) => {
                draft.activeLibrary = action.payload;
                draft.activeLibraryId = action.payload.Id;
                draft.librarySourceStatus = false;
                draft.loadingLibraryDetail = true;
            });
        case ACTION_TYPES.GET_REPORT_STATUS:
            return produce(state, (draft) => {
                draft.reportStatus = action.payload;
                draft.reportSourceStatus = true
            });
        case ACTION_TYPES.OPEN_TOASTR:
            return produce(state, (draft) => {
                draft.toastrAlert = action.payload;
            })
        case ACTION_TYPES.SET_SOURCE_MARKUP:
            return produce(state, (draft) => {
                draft.sourceMarkup = action.payload;
                draft.loadingSidebySideCompare = action.payload.Positions ? true : false
            })
        case ACTION_TYPES.GET_PROJECT:
            return produce(state, (draft) => {
                draft.projects = action.payload;
                draft.mapProjectId2ProjectIdx = {};
                draft.projects.map((project, idx) => {
                    draft.mapProjectId2ProjectIdx[project.Id] = idx;
                })

            })
        case ACTION_TYPES.GET_PROJECT_FILTER:
            return produce(state, (draft) => {
                draft.filteredProjects = action.payload;
            })
        case ACTION_TYPES.SET_ACTIVE_REPORT:
        case ACTION_TYPES.CHANGE_REPORT_CARD:
            return produce(state, (draft) => {
                draft.sourceMarkup = {};
                draft.activeSource = {
                    data: {
                        Id: null
                    },
                };
                draft.sources = [];
                draft.searchedSources = [];
                draft.reportMarkup = [];
                draft.textOverlay = [];
                draft.activeReport = {};
                draft.reportId = Number(action.payload);
                draft.activeReportId = Number(action.payload);
                draft.loadingSource = false;
                draft.loadingSourceDetail = false;
                draft.loadingReportDetail = false;
                draft.loadingSidebySideCompare = false;
                draft.reportSourceStatus = false;
                draft.searchTextValue = '';
                draft.selectedReportIds = action.payload ? [Number(action.payload)] : [];
                draft.textOverlay = [];
                draft.overlayStatistics = [];
            })
        case ACTION_TYPES.SET_ACTIVE_LIBRARY:
        case ACTION_TYPES.CHANGE_LIBRARY_CARD:
            return produce(state, (draft) => {
                draft.sourceMarkup = {};
                draft.activeSource = {
                    data: {
                        Id: null
                    },
                };
                draft.sources = [];
                draft.searchedSources = [];
                draft.reportMarkup = [];
                draft.textOverlay = [];
                draft.activeLibrary = {};
                draft.libraryId = action.payload;
                draft.activeLibraryId = action.payload;
                draft.loadingSource = false;
                draft.loadingSourceDetail = false;
                draft.loadingLibraryDetail = false;
                draft.loadingSidebySideCompare = false;
                draft.librarySourceStatus = false;
                draft.searchTextValue = '';
                draft.selectedLibraryIds = [action.payload];
            })
        case ACTION_TYPES.RESET_REPORT:
            return produce(state, (draft) => {
                draft.resetReport = action.payload;
            });
        case ACTION_TYPES.GET_REPORT_STATUS_MESSAGE:
            return produce(state, (draft) => {
                draft.reportStatusMessage = action.payload;
            });
        case ACTION_TYPES.SET_SOURCE_FILTER:
            return produce(state, (draft) => {
                draft.sourceFilter = { ...state.sourceFilter, ...action.payload };
                draft.sourceFilter.changeNo++;

            });
        case ACTION_TYPES.CLEAR_REPORT_FILTER:
            return produce(state, (draft) => {
                draft.reportFilter.projectId = "";
                draft.reportFilter.date = "";
                draft.reportFilter.search = "";
                draft.reportFilter.state = "";
                draft.reportFilter.userId = "";
                draft.reportsChangeNo++;
            });
        case ACTION_TYPES.CLEAR_PROJECT_FILTER:
            return produce(state, (draft) => {
                draft.projectFilter.search = "";
                draft.projectsFilterChangeNo++;
            });
        case ACTION_TYPES.APPLY_REPORT_FILTER:
            var newState = produce(state, (draft) => {
                draft.reportFilter = { ...action.payload };
                draft.reportPagination = { pageno: 1 };
                draft.reportsChangeNo++;
            });
            return newState;
        case ACTION_TYPES.APPLY_PROJECT_FILTER:
            return produce(state, (draft) => {
                draft.projectFilter = { ...action.payload };
                draft.projectsFilterChangeNo++;
            });
        case ACTION_TYPES.CLEAR_LIBRARY_FILTER:
            return produce(state, (draft) => {
                draft.libraryFilter.projectId = "";
                draft.libraryFilter.date = "";
                draft.libraryFilter.search = "";
                draft.libraryFilter.state = "";
                draft.librariesChangeNo++;
            });
        case ACTION_TYPES.APPLY_LIBRARY_FILTER:
            var newStateLibrary = produce(state, (draft) => {
                draft.libraryFilter = { ...action.payload };
                draft.libraryPagination = { pageno: 1 };
                draft.librariesChangeNo++;
            });
            return newStateLibrary;
        case ACTION_TYPES.OPEN_PAYMENT_DIALOG:
            return produce(state, (draft) => {
                draft.ui.paymentDialogVisible = action.payload;
                if (action.payload)
                    draft.checkout.paymentStep = 0;
            });
        case ACTION_TYPES.SET_CREDIT_DATA:
            return produce(state, (draft) => {
                draft[action.payload.key] = action.payload.data;
            });
        case ACTION_TYPES.SET_CREDIT_COSTS:
            return produce(state, (draft) => {
                draft.creditCosts = { ...draft.creditCosts, ...action.payload };
            });
        case ACTION_TYPES.SET_PROJECT_DATA:
            return produce(state, (draft) => {
                draft.selectedProject.UploadFormActive = action.payload.data;
            });
        case ACTION_TYPES.INPUT_URL_POPUP:
            return produce(state, (draft) => {
                draft.openInputUrlPopup = action.payload;
            });
        case ACTION_TYPES.CREATE_PROJECT_POPUP:
            return produce(state, (draft) => {
                draft.openCreateProjectPopup = action.payload;
            });
        case ACTION_TYPES.SET_PROPERTIES_FORM_DATA:
            return produce(state, (draft) => {
                draft.propertiesForm = action.payload;
            });
        /////////////////////////// Handling of file uploads /////////////////
        case ACTION_TYPES.SET_UPLOADED_FILES:
            if ([...state.uploadedFiles, ...action.payload].length > 100) {
                return produce(state, (draft) => {
                    draft.uploadedFiles = state.uploadedFiles
                });
            }
            return produce(state, (draft) => {
                draft.uploadedFiles = [...state.uploadedFiles, ...action.payload]
            });
        case ACTION_TYPES.SET_UPLOADED_FILES_STATUS:
            return produce(state, (draft) => {
                draft.uploadedFilesStatus = action.payload.Files
            });
        case ACTION_TYPES.REMOVE_UPLOADED_FILE:
            return produce(state, (draft) => {
                draft.uploadedFiles = state.uploadedFiles.filter(file => file.id !== action.payload) || [];
                draft.uploadedFilesStatus = state.uploadedFilesStatus.filter(file => file.UploadId !== action.payload) || [];
            });

        case ACTION_TYPES.CANCEL_FILES_UPLOAD:
            return produce(state, (draft) => {
                draft.newCheckSettings.uploadedFiles = [];
                draft.uploadedFilesStatus = [];
                draft.uploadedFiles = [];
            });
        case ACTION_TYPES.SET_LANGUAGE:
            return produce(state, (draft) => {
                draft.lang = action.payload;
            });
        case ACTION_TYPES.RESET_NEWCHECK_SETTINGS:
            return produce(state, (draft) => {
                draft.newCheckSettings = {
                    ...state.newCheckSettings,
                    searchWeb: true,
                    searchLib: state.user.settings.searchInLibrary,
                    searchInLibraryProjects: [],
                    excludeUrlPatterns: [],
                    acceptUrlPatterns: [],
                    excludeByWhitelist: state.user.settings.useAuthWhitelist,
                    acceptCitedUrls: state.user.settings.autoAcceptSources,
                    considerTags: true,
                    text: '',
                    revisionReportId: null,
                    addToLibrary: state.user.settings.addToLibrary,
                };
                draft.creditCosts = {
                    words: 0,
                    credits: 0,
                    pages: 0,
                    texts: 0
                };

            });
        case ACTION_TYPES.PERFORMANCE_CHECK_LIST:
            return produce(state, (draft) => {
                draft.performCheckLayout = action.payload;
            });
        case ACTION_TYPES.HANDLE_PAGINATION:
            return produce(state, (draft) => {
                draft.reportPagination = { ...action.payload };
                draft.user.settings.pagesize = (action.payload.pagesize) ? action.payload.pagesize : draft.user.settings.pagesize;
                draft.reportsChangeNo++;
            });
        case ACTION_TYPES.HANDLE_LIBRARY_PAGINATION:
            return produce(state, (draft) => {
                draft.libraryPagination = { ...action.payload };
                draft.user.settings.pagesize = (action.payload.pagesize) ? action.payload.pagesize : draft.user.settings.pagesize;
                draft.librariesChangeNo++;
            });
        case ACTION_TYPES.HANDLE_PROJECT_PAGINATION:
            return produce(state, (draft) => {
                draft.projectPagination = { ...action.payload };
                let projects_ = draft.filteredProjects;
                if (projects_ && projects_.length > 1) {
                    if (draft.projectPagination.sortby === 'PlagChecks' || draft.projectPagination.sortby === 'LibraryTexts') {
                        projects_.sort((a, b) => {
                            return (+a[draft.projectPagination.sortby] - +b[draft.projectPagination.sortby]);
                        });
                    } else {
                        projects_.sort((a, b) => {
                            return ('' + a[draft.projectPagination.sortby]).localeCompare(b[draft.projectPagination.sortby]);
                        });
                    }
                    if (draft.projectPagination.sortdir === 'desc') {
                        projects_.reverse();
                    }
                    draft.filteredProjects = projects_;
                }
            });
        case ACTION_TYPES.SELECTED_ROW_TABLE:
            return produce(state, (draft) => {
                draft.selectedRow = action.payload;
            });
        case ACTION_TYPES.CLEAR_REPORT_PERFORMACE_DATA:
            return produce(state, (draft) => {
                /* draft.reportFilter = {
                     projectId: "",
                     search: "",
                     date: "",
                     state: "",
                 };*/
                draft.reportPagination = {
                    pageno: 1,
                    //    sortdir: "desc",
                    //   sortby: "date",
                    //   countonly: 0
                };

                draft.performCheckLayout = 'list';
                draft.totalReportsNumber = 0;
                draft.selectedRow = []
            });
        case ACTION_TYPES.OPEN_CONFIRMATION_POPUP:
            return produce(state, (draft) => {
                draft.openConfirmationPopup = action.payload;
            });
        case ACTION_TYPES.OPEN_CONFIRMATION_DIALOG:
            return produce(state, (draft) => {
                draft.ui.confirmationDialog = { ...action.payload, visible: true };
            });
        case ACTION_TYPES.CLOSE_CONFIRMATION_DIALOG:
            return produce(state, (draft) => {
                draft.ui.confirmationDialog = { ...draft.ui.confirmationDialog, visible: false };
            });
        case ACTION_TYPES.OPEN_LOG_DIALOG:
            return produce(state, (draft) => {
                draft.ui.logDialog = { ...action.payload, visible: true };
            });
        case ACTION_TYPES.OPEN_PASTE_DIALOG:
            return produce(state, (draft) => {
                draft.ui.pasteDialog = { ...action.payload, visible: true };
            });

        case ACTION_TYPES.CLOSE_LOG_DIALOG:
            return produce(state, (draft) => {
                draft.ui.logDialog = { ...draft.ui.logDialog, visible: false };
            });
        case ACTION_TYPES.CLOSE_PASTE_DIALOG:
            return produce(state, (draft) => {
                draft.ui.pasteDialog = { ...draft.ui.pasteDialog, visible: false };
            });

        case ACTION_TYPES.SET_PROPERTIES_DATA_VALUE:
            return produce(state, (draft) => {
                draft.propertiesDataValue = action.payload;
            });
        case ACTION_TYPES.CHANGE_REPORT_SELECTION:
            return produce(state, (draft) => {
                draft.selectedReportIds = action.payload || [];
                draft.collusion.sources = [];
                draft.collusion.left = 0;
            });
        case ACTION_TYPES.CHANGE_PROJECT_SELECTION:
            return produce(state, (draft) => {
                draft.selectedProject = action.payload;
            });
        case ACTION_TYPES.SET_COLLUSION:
            return produce(state, (draft) => {
                draft.collusion = { ...draft.collusion, ...action.payload }
            });
        case ACTION_TYPES.CHANGE_LIBRARY_SELECTION:
            return produce(state, (draft) => {
                draft.selectedLibraryIds = action.payload;
            });
        case ACTION_TYPES.NOTIFY_REPORTS_CHANGED:
            return produce(state, (draft) => {
                draft.reportsChangeNo++;
            });
        case ACTION_TYPES.NOTIFY_LICENSEUSERS_CHANGED:
            return produce(state, (draft) => {
                draft.licenseUsersChangeNo++;
            });
        case ACTION_TYPES.NOTIFY_PROJECTS_CHANGED:
            return produce(state, (draft) => {
                draft.projectsChangeNo++;
            });
        case ACTION_TYPES.NOTIFY_LIBRARIES_CHANGED:
            return produce(state, (draft) => {
                draft.librariesChangeNo++;
            });
        case ACTION_TYPES.SET_DRAFT_REPORT:
            return produce(state, (draft) => {
                draft.draftReport = {
                    Name: action.payload.title || "",
                    Author: action.payload.author || "",
                    Scheduled: action.payload.date || {},
                    Comment: action.payload.comment || "",
                    ProjectId: action.payload.projectid || ""
                }
            });
        case ACTION_TYPES.SET_DRAFT_PROJECT:
            return produce(state, (draft) => {
                draft.draftProject = {
                    Name: action.payload.title,
                    Date: action.payload.date,
                    Description: action.payload.comment,
                    uploadformactive: action.payload.uploadformactive,
                    uploadformheader: action.payload.uploadformheader,
                    uploadformdescription: action.payload.uploadformdescription,
                }
            });
        case ACTION_TYPES.SET_DRAFT_LIBRARY:
            return produce(state, (draft) => {
                draft.draftLibrary = {
                    Name: action.payload.title,
                    Author: action.payload.author,
                    Date: action.payload.date,
                    Comment: action.payload.comment,
                    ProjectId: action.payload.projectid
                }
            });
        case ACTION_TYPES.SET_CHECKOUT_DETAILS:
            return produce(state, (draft) => {
                draft.checkout = { ...draft.checkout, ...action.payload };
                draft.checkout.education.complete = Boolean(draft.checkout.education.contactName && draft.checkout.education.contactMail && draft.checkout.education.orgName && draft.checkout.education.orgType);
                draft.checkout.loginComplete = Boolean(draft.checkout.loginMail && draft.checkout.Password);
            });
        case ACTION_TYPES.SET_EXCLUDE_SOURCES:
            return produce(state, (draft) => {
                draft.checkedExcludeSources = action.payload.data;
            });
        case ACTION_TYPES.SET_ACCEPT_SOURCE:
            return produce(state, (draft) => {
                draft.checkedAcceptSource = action.payload.data;
            });
        case ACTION_TYPES.GET_REPORT_STATISTICS_BY_PROJECT:
            return produce(state, (draft) => {
                draft.reportStatisticsByProject = action.payload;
            });
        case ACTION_TYPES.GET_REPORT_STATISTICS_BY_MONTH:
            return produce(state, (draft) => {
                draft.reportStatisticsByMonth = action.payload;
            });
        case ACTION_TYPES.GET_NEWS:
            return produce(state, (draft) => {
                draft.news = action.payload.data;
            });
        case ACTION_TYPES.GET_FAQS:
            return produce(state, (draft) => {
                draft.faqs = action.payload.data;
            });
        case ACTION_TYPES.SHOW_FULLSCREEN_LOADING:
            return produce(state, (draft) => {
                draft.ui.fullScreenLoading = action.payload.visible;
                draft.ui.fullScreenLoadingText = action.payload.text;
            });
        case ACTION_TYPES.SET_UI:
            return produce(state, (draft) => {
                // make sure only one of plagCheckMenuExpanded and libraryMenuExpanded is true at any time
                if (("plagCheckMenuExpanded" in action.payload) || ("libraryMenuExpanded" in action.payload) || ("monitoringMenuExpanded" in action.payload) || ("toolsMenuExpanded" in action.payload)) {
                    draft.ui = { ...draft.ui, plagCheckMenuExpanded: false, libraryMenuExpanded: false, monitoringMenuExpanded: false, toolsMenuExpanded: false };
                }
                
                /*
                // In case sources / ai detector view has been toggeled to statistics view, preselect it with default ai typicity 
                if (action.payload.sourcesView == "statistics") {
                    draft.ui = { ...draft.ui, statisticsType: 'kil'}
                }
                */
                draft.ui = { ...draft.ui, ...action.payload };
            });
        case ACTION_TYPES.SET_USER_SETTINGS:
            return produce(state, (draft) => {
                draft.user.settings = { ...draft.user.settings, ...action.payload };
            });
        case ACTION_TYPES.SET_NEWCHECK_SETTINGS:
            return produce(state, (draft) => {
                draft.newCheckSettings = { ...draft.newCheckSettings, ...action.payload };
                draft.newCheckSettings.changeNo = state.newCheckSettings.changeNo + 1;
                draft.newCheckSettings.libraryTexts = draft.newCheckSettings.libraryTexts.filter((lt) => {
                    return (lt.Fingerprint == 0);
                })
            });
        case ACTION_TYPES.SET_NEWTEXT_SETTINGS:
            return produce(state, (draft) => {
                draft.newTextSettings = { ...draft.newTextSettings, ...action.payload };
                draft.newTextSettings.changeNo = state.newTextSettings.changeNo + 1;
            });

        case ACTION_TYPES.SET_ORDERS:
            return produce(state, (draft) => {
                draft.user.orders = action.payload;
            });
        case ACTION_TYPES.OPEN_REPORT_DOWNLOAD_DIALOG:
            return produce(state, (draft) => {
                draft.ui.downloadReportDialogOpen = true;
                draft.downloadReportIds = action.payload;

            });
        case ACTION_TYPES.SET_ADMINLICENSE:
            return produce(state, (draft) => {
                draft.licenseAdmin = { ...draft.licenseAdmin, ...action.payload };

            });


        default:
            return state;
    }

}

function resetWizardStepsOnLogin(state, draft) {

    if ((!state.user.loggedIn || state.user.guest) && draft.user.loggedIn && !draft.user.guest) {
        draft.checkout.wizard.step = 0;
    }
    return draft;
}

